import{createModalContext}from"../../modal";export const[CloseAllModalProvider,useCloseAllModalView,useCloseAllModalActions]=createModalContext('CloseAll');